import Lang from "@vendors-fr/messages";
import '@commons-fr/combobox';
import {
    copyDefaultCoupon,
    carrierAction,
    checkShippingForTwIslands, count_main_product_qty, get_card_staging,
    getMinDate,
    getParams,
    getShopShippingExceptDate, getUserChooseOrDefaultShipping, initSelector,
    internationalAddress,
    invoiceAction,
    paymentAdditionalDisplay,
    paymentButton, recipient_selected_data, recipientBox, refreshOrderFields,
    refreshPaymentFields,
    setCradPaymentArea,
    setEmailPlaceholder,
    setInternationalCountry, setInvoice,
    setNameMaxlength,
    setPhonePlaceholder,
    setShippingTime,
    setStoreCode,
    setStorePickupTime,
    setUserChoosePayment, setUserChooseShipping,
    shippingCostDisplay,
    shippingDatePicker,
    shippingDateAction,
    shippingDateShow,
    shippingMessage,
    showRedeemRules,
    showReservationRules,
    superMallBox,
} from "@plugins-fr/payment";
import {DialogMessage} from "@plugins-fr/dialogMessage";
import {
    checkPreorderperiodExists, getCartAjaxUrl,
    refreshSelectorSyncSpan,
    selectorSyncSpan,
    setCartItem
} from "@plugins-fr/script";
import {count_add_price_qty} from "@plugins-fr/payment";
import '@vendors-fr/jquery.menu';
import {ExchangeProductStandardToggle, NormalProductStandardToggle} from "./productStandardToggle";
import "jquery-confirm";
import {JconfirmTemplateHelper} from "@plugins-fr/JconfirmTemplateHelper";
import {exchangeProductLightbox} from "@plugins-fr/exchangeProduct";
import {ReservableProductEventToggle} from "./reservableProductEventToggle";
import {PushAds} from "@commons-fr/pushAds";
import {UserStatusService} from "@commons-fr/userStatusService";
import {AmericaMarketStorage} from "@commons-fr/americaMarketStorage";
import {
    bookingAddPriceModalData,
    checkInputQty,
    checkMinusBtn,
    checkPlusBtn,
    checkReservableAddPriceQuantity,
    getPaymentReservableDom,
    initGetAllAddPrice,
    initRentableAddPriceModal
} from "@plugins-fr/reservableAddPrice";
import {AddPriceFactory, checkAddPriceQuantity} from "@plugins-fr/retailProductAddPrice";
import {
    getProductCustomFieldsAndRefreshRender, ProductCustomFieldDataStorage, ProductFormValidateActionState,
    ShippingCustomFields
} from "@plugins-fr/CustomFields";
import {cartCheckoutPage} from "@commons/userTracks/viewActionName";
import {recordUserEventTrack, recordUserViewTrack} from "@commons/userTracks/userTrack";
import {
    checkoutPageAddPriceItemAddToCart,
    checkoutPageChangeAddPriceItemQuantity,
    checkoutPageChangeCartAddPriceItemQuantity,
    checkoutPageChangeBundleItemQuantity,
    checkoutPageChangeExchangeItemQuantity,
    checkoutPageChangeProductItemQuantity,
    checkoutPageDeleteAddPriceItem, checkoutPageDeleteBundleItem,
    checkoutPageDeleteExchangeItem,
    checkoutPageDeleteProductItem,
    checkoutPageSelectGift,
    checkoutPageSelectPayment,
    checkoutPageSelectShipping
} from "@commons/userTracks/eventActionName";
import {
    ADD_RENTABLE_ADDPIRCE_ITEM, ADD_RENTABLE_ITEM,
    checkRentableAddPriceQuantityByStandardId,
    REMOVE_RENTABLE_ADDPRICE_ITEM,
    REMOVE_RENTABLE_ITEM, UPDATE_RENTABLE_QUANTITY
} from "@plugins-fr/rentableCartPlugin";


function checkRetailAddPriceQuantityByStandardId(standardId)
{
    const mainItemQuantity = $(".js_cart_list_quantity[data-standard-id=" + standardId + "]").val();
    const addPriceCondition = getRetailAddPricePurchaseConditionByStandardId(standardId);
    const addPriceItems = AddPriceFactory.buildAddPriceItemList(getRetailAddPriceItemsByStandardId(standardId));
    const check = checkAddPriceQuantity(mainItemQuantity, addPriceItems, addPriceCondition);

    if (! check.status) {
        new DialogMessage({
            'title': check.errorMessage,
        }).handle();
    }

    return check.status;
}

function checkReservationAddPriceQuantityByStandardId(standardId, addPriceStandardId)
{
    const mainItemQuantity = $(".js_cart_list_quantity[data-standard-id=" + standardId + "]").val();
    const addPriceItem = $(".js_cart_list_add_price_quantity[data-add-price-standard-id=" + addPriceStandardId + "]");
    const addPriceCondition = addPriceItem.data('purchase-condition');
    const addPriceMaxLimit = addPriceItem.data('max-limit');
    const check = checkReservableAddPriceQuantity(mainItemQuantity, addPriceItem, addPriceCondition, addPriceMaxLimit);

    if (! check.status) {
        new DialogMessage({
            'title': check.errorMessage,
        }).handle();
    }

    return check.status;
}

function getRetailAddPricePurchaseConditionByStandardId(standardId)
{
    const condition = $('.js_cart_item_list[data-standard-id="'+standardId+'"]').find('.js_retail_addprice_purchase_condition').val();
    const maxLimit = $('.js_cart_item_list[data-standard-id="'+standardId+'"]').find('.js_retail_addprice_purchase_condition_maxlimit').val();
    return AddPriceFactory.buildAddPriceConditions(condition, maxLimit);
}

function getRetailAddPriceItemsByStandardId(standardId)
{
    let addPrices = [];
    $(".js_cart_list_add_price_quantity[data-standard-id=" + standardId + "]").each(function(){
        addPrices.push({
            'standard_id': $(this).attr('data-add-price-standard-id'),
            'quantity': $(this).val(),
        });
    });

    return addPrices;
}

$(function () {
    var cart_detail_area = $('#js_cart_detail_area');
    const mobileProductStandardPushDom = $('.js_cart_push_block');

    initSelector();
    showRedeemRules();
    showReservationRules();

    var JS_VARS = JSON.parse(shops);
    var JS_VARS_THEME_STYLE = JSON.parse(themeButtonStyle);

    var buyer_info = buyer_info_unimportant;

    setInvoice(buyer_info);

    $('.js_member_recipient').on("click", function () {
        recipientBox();
    });
    $('.js_member_supermall').on("click", function () {
        superMallBox();
    });

    $(document).on("click", ".js_service_redeem_pop", function () {
        $.confirm({
            template: JconfirmTemplateHelper.getTemplate({
                'templateType': '01',
                'theme': 'el_confirm el_popup_shopping_info'
            }),
            columnClass: 'col-md-10',
            closeIcon: false,
            icon: '',
            title: false,
            backgroundDismiss: true,
            draggable: false,
            offsetTop: 0,
            offsetBottom: 0,
            buttons: {
                cancelButton: {
                    keys: ['esc'],
                    text: '<span class="el_text_inner">' + Lang.get('frontend.cart.after_sales_service.btn.success') + '</span>',
                    btnClass: 'btn_confirm btn el_btn md solid el_rounded el_text m-0',
                    action: function () {
                        showOrderfields();
                    }
                }
            },
            onOpenBefore: function () {
                this.setContent('<header class="title_area mt-0"><hgroup class="title_content d-flex justify-content-between align-items-center"><h4 class="main_title">' + Lang.get('frontend.member.points.rules') + '</h4></hgroup><hr class="main_hr"></header><article class="el_popup_content inner_layout js_after_sales_redeem_info"></article>');
                this.$el.find('.btn_confirm').attr('style', JS_VARS_THEME_STYLE.subButtonStyle);
                this.$el.find('.btn_confirm').data('style', JS_VARS_THEME_STYLE.subButtonStyle);
                this.$el.find('.btn_confirm').data('hover-style', JS_VARS_THEME_STYLE.subButtonHoverStyle);

                this.$el.find('.btn_confirm').hover(
                    function () {
                        $(this).attr('style', $(this).data('hover-style'));
                    },
                    function () {
                        $(this).attr('style', $(this).data('style'));
                    }
                );
            },

        });
    });

    $(document).on("click", ".js_service_pop", function () {
        $.confirm({
            template: JconfirmTemplateHelper.getTemplate({
                'templateType': '01',
                'theme': 'el_confirm el_popup_shopping_info'
            }),
            columnClass: 'col-md-10',
            closeIcon: false,
            icon: '',
            title: false,
            backgroundDismiss: true,
            draggable: false,
            offsetTop: 0,
            offsetBottom: 0,
            buttons: {
                cancelButton: {
                    keys: ['esc'],
                    text: '<span class="el_text_inner">' + Lang.get('frontend.cart.after_sales_service.btn.success') + '</span>',
                    btnClass: 'btn_confirm btn el_btn md solid el_rounded el_text m-0',
                    action: function () {
                        showOrderfields();
                    }
                }
            },
            onOpenBefore: function () {
                this.setContent('<header class="title_area mt-0"><hgroup class="title_content d-flex justify-content-between align-items-center"><h4 class="main_title">' + Lang.get('frontend.guide.title.aftersales') + '</h4></hgroup><hr class="main_hr"></header><article class="el_popup_content inner_layout js_after_sales_info"></article>')
                this.$el.find('.btn_confirm').attr('style', JS_VARS_THEME_STYLE.subButtonStyle);
                this.$el.find('.btn_confirm').data('style', JS_VARS_THEME_STYLE.subButtonStyle);
                this.$el.find('.btn_confirm').data('hover-style', JS_VARS_THEME_STYLE.subButtonHoverStyle);

                this.$el.find('.btn_confirm').hover(
                    function () {
                        $(this).attr('style', $(this).data('hover-style'));
                    },
                    function () {
                        $(this).attr('style', $(this).data('style'));
                    }
                );
            },
        });
    });

    $(document).on("click", ".js_reservation_pop", function () {
        $.confirm({
            template: JconfirmTemplateHelper.getTemplate({
                'templateType': '01',
                'theme': 'el_confirm el_popup_shopping_info'
            }),
            columnClass: 'col-md-10',
            closeIcon: false,
            icon: '',
            title: false,
            backgroundDismiss: true,
            draggable: false,
            offsetTop: 0,
            offsetBottom: 0,
            buttons: {
                cancelButton: {
                    keys: ['esc'],
                    text: '<span class="el_text_inner">' + Lang.get('frontend.cart.after_sales_service.btn.success') + '</span>',
                    btnClass: 'btn_confirm btn el_btn md solid el_rounded el_text m-0',
                    action: function () {
                        showOrderfields();
                    }
                }
            },
            onOpenBefore: function () {
                this.setContent('<header class="title_area mt-0"><hgroup class="title_content d-flex justify-content-between align-items-center"><h4 class="main_title">' + Lang.get('frontend.guide.title.appointment') + '</h4></hgroup><hr class="main_hr"></header><article class="el_popup_content inner_layout js_reservation_info"></article>');
                this.$el.find('.btn_confirm').attr('style', JS_VARS_THEME_STYLE.subButtonStyle);
                this.$el.find('.btn_confirm').data('style', JS_VARS_THEME_STYLE.subButtonStyle);
                this.$el.find('.btn_confirm').data('hover-style', JS_VARS_THEME_STYLE.subButtonHoverStyle);

                this.$el.find('.btn_confirm').hover(
                    function () {
                        $(this).attr('style', $(this).data('hover-style'));
                    },
                    function () {
                        $(this).attr('style', $(this).data('style'));
                    }
                );
            }
        });
    });

    $(document).on("click", ".js_aftee_pop", function () {
        $.confirm({
            template: JconfirmTemplateHelper.getTemplate({
                'templateType': '01',
                'theme': 'el_confirm'
            }),
            columnClass: 'col-lg-10',
            closeIcon: false,
            icon: 'icon-new_exclaim_circle',
            title: false,
            offsetTop: 0,
            offsetBottom: 0,
            buttons: {
                cancelButton: {
                    keys: ['esc'],
                    text: '<span class="el_text_inner">' + Lang.get('frontend.cart.after_sales_service.btn.success') + '</span>',
                    btnClass: 'btn_cancel',
                    action: function () {
                        showOrderfields();
                    }
                }
            },
            onOpenBefore: function () {
                this.setContent('<span class="content_confirm_inner"><div class="form_group popup_tips_inner form_lastmargin"><header class="title_area clearfix"><hgroup class="title_content clearfix"><h4 class="main_title">'
                  + Lang.get('frontend.guide.title.aftee')
                  + '</h4><h5 class="main_sub font_avant_garde">'
                  + '</h5></hgroup><hr class="main_hr"></header><article class="el_popup_content inner_layout">'
                  + '<h3 class="mb-15">AFTEE是安心方便的先享受後支付服務。在日本一年間累積超過1,580萬個使用者。</h3>'
                  + '<h4 class="mt-20 mb-10"><b>關於AFTEE先享後付</b></h4>'
                  + '<ol class="">'
                  + '<li>於結帳方式選擇AFTEE先享後付，將跳出AFTEE手機驗證視窗。</li>'
                  + '<li>進行簡訊驗證之後，即可完成結帳手續。</li>'
                  + '<li>結帳手續完成當下不需繳費，商品會配送至您的指定地址，或依商家規定方式通知您領取使用。</li>'
                  + '<li>商家向您請款或商品出貨後，您的手機會收到繳費通知簡訊，APP會員則可登入APP確認訂單狀態。</li>'
                  + '<li>待收到商品或使用訂購之服務後，請透過便利商店代收服務或ATM（包括網路ATM）繳費等方式完成付款手續（跨行轉帳以外免手續費）。</li>'
                  + '</ol>'
                  + '<h5 class="m-0">※請留意繳費期限最短為14天。唯有下載APP成為AFTEE會員者方能享有最長45天付款之服務。</h5>'
                  + '<h4 class="mb-10">注意事項</h4>'
                  + '<ol class="">'
                  + '<li>透過由恩沛科技股份有限公司提供之「AFTEE先享後付」服務完成的交易，需依本服務之必要範圍內提供個人資料，並將交易相關給付款項請求債權轉讓予恩沛科技股份有限公司。</li>'
                  + '<li>關於個人資料處理事宜，請瀏覽以下網址：https://aftee.tw/terms/#terms3</li>'
                  + '<li>未成年的使用者請事先徵得法定代理人或監護人之同意方可使用AFTEE，若未經同意申辦者引起之損失，本公司不負相關責任。</li>'
                  + '<li>初次使用AFTEE時，將依認證結果及本公司審查結果，核予每個人不同之上限額度，最高額度可達10,000元。若款項超過繳費期限，將根據當次的金額加收年利率16％的逾期滯納金。未成年的使用者，請事先徵得法定代理人或監護人之同意方可使用AFTEE。</li>'
                  + '<li>嚴禁一人註冊多個帳號或使用他人資訊註冊。</li>'
                  + '</ol>' +
                  '<h5 class="m-0">※若發現惡意使用之情形，恩沛科技股份有限公司將有權停止該用戶之使用額度並採取法律行動。</h5>'
                  + '</article></span>');
            }
        });
    });

    cart_detail_area.on('click','.js_add_price_detail',function(){
        let parentDom = $(this).closest('.js_add_price_row');
        let parentQtyDom = parentDom.find('.js_cart_list_add_price_quantity');
        let id = parentQtyDom.data('add-price-id');
        let standardId = parentQtyDom.data('add-price-standard-id');
        let url = reservableAddPriceDeatil + `/${id}/${standardId}`;
        $.ajax({
            url: url,
            method: 'GET',
            success: function(response) {
                if (response.status === false) {
                    new DialogMessage({
                        'title': response.errorMessage || '系統忙碌中，請稍後再試。',
                    }, {
                        'closeTimeout': 5000
                    }).handle();
                } else {
                    $('#detailAddService__modal .modal-body').html(response.html);
                    $('#detailAddService__modal').modal('show');
                }
            }
        });
    });

    $(document).on('mouseenter', '.js_resevable_add_price_cancel', function () {
        $(this).attr('style', $(this).data('hover-style'));
    });

    $(document).on('mouseleave', '.js_resevable_add_price_cancel', function () {
        $(this).attr('style', $(this).data('style'));
    });

    cart_detail_area.on('click','.js_show_rentable_add_price',function(event){
        event.preventDefault();

        const mainItemId = $(this).data('main-item-id');
        const parentDom = $('.js_rentable_cart_item[data-item-id="' + mainItemId + '"]');
        let productId = parentDom.data('product-id');
        let url = reservableAddpriceList + `/${productId}`;

        $.ajax({
            url: url,
            method: 'GET',
            success: function(response) {
                if (response.status === false) {
                    new DialogMessage({
                        'title': response.errorMessage || '系統忙碌中，請稍後再試。',
                    }, {
                        'closeTimeout': 5000
                    }).handle();
                } else {
                    bookingAddPriceModalData.set.setIsRentableType();
                    bookingAddPriceModalData.set.setMainItemId(mainItemId);
                    $('#addServiceListModal .modal-body').html(response.html);
                    initRentableAddPriceModal(parentDom);
                    $('#addServiceListModal').modal('show');
                }
            }
        });
    });

    cart_detail_area.on('click','.js_show_reservable_add_price',function(event){
        event.preventDefault();
        const mainItemId = $(this).data('main-item-id');
        let productId = $(this).data('id');
        let parentDom = $(this).closest('.js_cart_item_list');
        let url = reservableAddpriceList + `/${productId}`;

        $.ajax({
            url: url,
            method: 'GET',
            success: function(response) {
                if (response.status === false) {
                    new DialogMessage({
                        'title': response.errorMessage || '系統忙碌中，請稍後再試。',
                    }, {
                        'closeTimeout': 5000
                    }).handle();
                } else {
                    bookingAddPriceModalData.set.setIsReservableType();
                    bookingAddPriceModalData.set.setMainItemId(mainItemId);
                    $('#addServiceListModal .modal-body').html(response.html);
                    initGetAllAddPrice(parentDom);
                    $('#addServiceListModal').modal('show');
                }
            }
        });
    });

    cart_detail_area.on('click','.js_reservable_qty_plus',function(event){
        event.preventDefault();
        let qtyDom = $(this).closest('.js_outline').find('.js_reservable_add_price_qty');
        let mainDom = getPaymentReservableDom(qtyDom);
        checkPlusBtn($(this), mainDom);
    });

    cart_detail_area.on('click','.js_reservable_qty_minus',function(event){
        event.preventDefault();
        checkMinusBtn($(this));
    });

    cart_detail_area.on('change','.js_reservable_add_price_qty',function(event){
        event.preventDefault();
        let mainDom = getPaymentReservableDom($(this));
        checkInputQty($(this), mainDom);
    });

    cart_detail_area.on('change','.js_product_qty',function(){
        // 主商品變動時一併更動加購品
        initGetAllAddPrice($(this).closest('.js_cart_item_list'));
    });

    function recordAddOnAddToCartTrack(eventName, action, cartPrams)
    {
        let trackParams = {
            'parent_product_id': Number(cartPrams.product_id),
            'parent_standard_id': Number(cartPrams.standard_id),
            'add_on': []
        };
        Object.values(cartPrams.add_add_prices).forEach((value) => {
            if (parseInt(value.quantity) > 0) {
                trackParams.add_on.push({
                    'product_id': Number(value.id),
                    'standard_id': Number(value.standard_id),
                    'quantity': Number(value.quantity),
                });
            }
        });
        recordUserEventTrack(eventName, getCartAjaxUrl(action), trackParams);
    }

    cart_detail_area.on('click','.js_popup_resevable_add_price_confirm',function(){
        if (bookingAddPriceModalData.method.isRentable()) {
            const mainItemId = bookingAddPriceModalData.get.getMainItemId();
            const mainRentableItemDom = $(`.js_rentable_cart_item[data-item-id="${mainItemId}"]`);

            let params = $.extend({}, getParams(), {
                product_id: mainRentableItemDom.data('product-id'),
                standard_id: mainRentableItemDom.data('standard-id'),
                rentable_start_timestamp_ms: mainRentableItemDom.data('rentable-start-at'),
                rentable_end_timestamp_ms: mainRentableItemDom.data('rentable-end-at'),
                rentable_unit: mainRentableItemDom.data('rentable-unit'),
                quantity: mainRentableItemDom.data('quantity'),
                removeItemAddprices: 'y',
                add_add_prices: []
            });

            $(this).closest('.modal-content').find('.js_outline').each(function(){
                let qtyDom = $(this).find('.js_reservable_add_price_qty');
                let qty = qtyDom.val(),
                    addPriceId = qtyDom.attr('data-add-price-id'),
                    addPriceStandardId = qtyDom.attr('data-add-price-standard-id');
                params.add_add_prices.push({
                    id: addPriceId,
                    quantity: qty,
                    standard_id: addPriceStandardId,
                });
            });

            // return;
            const action = ADD_RENTABLE_ITEM;
            setCartItem(action, params, function(response) {
                if (response.status) {
                    recordAddOnAddToCartTrack(checkoutPageAddPriceItemAddToCart, action, params);
                }
                shippingCostDisplay(response);
            });
        } else {
            const mainItemId = bookingAddPriceModalData.get.getMainItemId();
            const mainReservableQuantityDom = $(`.js_show_reservable_add_price[data-main-item-id="${mainItemId}"]`).closest('.js_cart_item_list').find('.js_product_qty');
            const productId = mainReservableQuantityDom.data('product-id');
            const standardId = mainReservableQuantityDom.data('standard-id');
            const reservableProductsEventsId = mainReservableQuantityDom.data('reservable-products-events-id');
            const date = mainReservableQuantityDom.data('date');

            let params = getParams();
            let addPriceParams = [];
            $(this).closest('.modal-content').find('.js_outline').each(function(){
                let qtyDom = $(this).find('.js_reservable_add_price_qty');
                let qty = qtyDom.val(),
                    addPriceId = qtyDom.attr('data-add-price-id'),
                    addPriceStandardId = qtyDom.attr('data-add-price-standard-id');
                addPriceParams.push({
                    id: addPriceId,
                    qty: qty,
                    quantity: qty,
                    standard_id: addPriceStandardId,
                });
            });
            params.product_id = productId;
            params.qty = mainReservableQuantityDom.val();
            params.standard_id = standardId;
            params.date = date;
            params.reservable_products_events_id = reservableProductsEventsId;
            params.removeItemAddprices = 'y';
            params.add_add_prices = addPriceParams;

            const action = 'add_reservable_cart_item_and_add_price_item_batch';
            setCartItem(action, params, function(response) {
                if (response.status) {
                    recordAddOnAddToCartTrack(checkoutPageAddPriceItemAddToCart, action, params);
                }
                shippingCostDisplay(response);
            });
        }
    });

    cart_detail_area.on('change','.js_radio_coupon_trigger',function(){
        const $radioCoupon = $(this).next('.js_radio_coupon_area');
        const $wrapper = $(this).parents('.js_radio_coupon_wrapper');
        $wrapper.find('.js_radio_coupon_area').removeAttr('style');
        $radioCoupon.attr('style', $radioCoupon.data('active-style'));

        if ($(this).val() === 'none') {
            $('.js_coupon').val('');
            var params = getParams();
            setCartItem('set_coupon', params, shippingCostDisplay);
        }
    })

    cart_detail_area.on('click','.js_choose_coupon',function(){

        $.ajax({
            url: memberCouponUrl,
            type: 'POST',
            dataType: 'json',
            success:function(response) {
                if (!response.status && response.message) {

                    new DialogMessage({
                        'icon': 'icon-new_exclaim_circle',
                        'title': response.message,
                    }, {
                        'closeTimeout': 5000
                    }).handle();

                    return false;
                }

                $.confirm({
                    template: JconfirmTemplateHelper.getTemplate({
                        'templateType': '01',
                        'theme': 'el_confirm el_popup_add_product'
                    }),
                    columnClass: 'col-md-10',
                    closeIcon: false,
                    icon: '',
                    title: false,
                    content: response.CartMemberCouponHtml,
                    draggable: false,
                    offsetTop: 0,
                    offsetBottom: 0,
                    buttons:false,
                    onContentReady: function(data, status, xhr){
                        const self = this;
                        self.addCouponCheckboxElems  = self.$content.find('.js_add_cart_coupon');
                        self.confirmButton  = self.$content.find('.js_btn_confirm');
                        self.cancelButton  = self.$content.find('.js_btn_cancel');
                        self.addpriceArea  = self.$content.find('.js_addcoupon_mobile_area');

                        // 勾選/取消
                        self.addCouponCheckboxElems.on('click', function (e) {
                            const checkboxElem = $(this);
                            const isChecked = checkboxElem.prop('checked');
                            let selectedCheckboxes = self.addCouponCheckboxElems.filter(':checked');

                            if (isChecked && selectedCheckboxes.length >= 1) {
                                // clean other checkbox
                                self.addCouponCheckboxElems.prop('checked', false);
                                self.addCouponCheckboxElems.each(function() {
                                    $( this ).addClass( "foo" );
                                    let otherItemDom = $( this ).closest('.js_addCoupon_item');
                                    let otherCheckboxBtnDom = $( this ).next();
                                    otherItemDom.attr('style', '');
                                    otherCheckboxBtnDom.attr('style', otherCheckboxBtnDom.data('style'));
                                    otherCheckboxBtnDom.text(otherCheckboxBtnDom.data('noselect'));
                                });
                            }

                            const couponItemDom = checkboxElem.closest('.js_addCoupon_item');
                            const checkboxBtnDom = checkboxElem.next();

                            checkboxElem.prop('checked', isChecked);

                            if (isChecked) {
                                couponItemDom.attr('style', couponItemDom.data('active-style'));
                                checkboxBtnDom.attr('style', checkboxBtnDom.data('active-style'));
                                checkboxBtnDom.text( checkboxBtnDom.data('selected'));
                            } else {
                                couponItemDom.attr('style', '');
                                checkboxBtnDom.attr('style',  checkboxBtnDom.data('style'));
                                checkboxBtnDom.text(checkboxBtnDom.data('noselect'));
                            }
                        });

                        self.addpriceArea.show()

                        self.confirmButton.click(function(){
                            let couponCode = $('.js_add_cart_coupon:checked').val();
                            $('.js_coupon').val(couponCode);

                            var params = getParams();
                            setCartItem('set_coupon', params, shippingCostDisplay);

                            self.close();
                        });

                        // cancel button
                        self.cancelButton.click(function(){
                            self.close();
                        });

                        self.confirmButton.hover(
                            function () {
                                $(this).attr('style', $(this).data('hover-style'));
                            },
                            function () {
                                $(this).attr('style', $(this).data('style'));
                            }
                        );
                        self.cancelButton.hover(
                            function () {
                                $(this).attr('style', $(this).data('hover-style'));
                            },
                            function () {
                                $(this).attr('style', $(this).data('style'));
                            }
                        );
                    }
                });
            }
        });
    })

    // 更改商品購買數量
    cart_detail_area.on('change', '.js_cart_list_quantity', function () {
        const isReservable = $(this).data('is-reservable') === 1;

        let qty = $(this).val();
        let standardId = $(this).attr('data-standard-id');
        let productId = $(this).attr('data-product-id');

        let checkStock = isSubscriptionCart == 1 ? true : false;
        let mainQty = count_main_product_qty(standardId);
        let params = getParams();

        params.qty = qty;
        params.standard_id = standardId;

        if (isReservable) {
            let date = $(this).data('date');
            let reservableProductsEventsId = $(this).data('reservable-products-events-id');
            params.reservable_products_events_id = reservableProductsEventsId;
            params.date = date;
            const action = 'update_reservable_item_quantity';
            let setCartItemCallback = (response) => {
                if (response.status) {
                    recordUserEventTrack(checkoutPageChangeProductItemQuantity, getCartAjaxUrl(action), {
                        'product_id': Number(productId),
                        'standard_id': Number(standardId),
                        'quantity': Number(qty),
                    });
                }

                shippingCostDisplay(response);
                getProductCustomFieldsAndRefreshRender({
                    url: productCustomFieldsUrl,
                    isMobile: typeof is_mobile !== 'undefined' && is_mobile === 1
                });
            }
            setCartItem(action, params, setCartItemCallback, checkStock);
        } else {
            if (!checkRetailAddPriceQuantityByStandardId(standardId)) {
                $(this).val($(this).attr('data-origin-qty'));
                return false;
            }

            const action = 'update_cart_item';
            setCartItem(action, params, function(response) {
                if (response.status) {
                    recordUserEventTrack(checkoutPageChangeProductItemQuantity, getCartAjaxUrl(action), {
                        'product_id': Number(productId),
                        'standard_id': Number(standardId),
                        'quantity': Number(qty),
                    });
                }

                shippingCostDisplay(response);
            }, checkStock);
        }
        $('.js_cart_list_del_item[data-standard-id=' + standardId + ']').attr('data-qty', qty);

    });

    cart_detail_area.on('change', '.js_reservable_location', function () {
        const standardId = $(this).data('product-standard-id');
        const reservableProductsEventsId = $(this).data('reservable-products-events-id');
        const date = $(this).data('date');
        const customerReservableLocation = $(this).val();
        const checkStock = isSubscriptionCart == 1 ? true : false;

        let params = getParams();

        params.standard_id = standardId;
        params.reservable_products_events_id = reservableProductsEventsId;
        params.date = date;
        params.customer_reservable_location = customerReservableLocation;

        setCartItem('update_customer_reservable_location', params, shippingCostDisplay, checkStock);
    });

    cart_detail_area.on('change', '.js_select_change', function () {
        selectorSyncSpan($(this));
    });

    refreshSelectorSyncSpan();


    // 一般商品更改商品規格
    const productStandardToggle = new NormalProductStandardToggle(cart_detail_area, mobileProductStandardPushDom, JS_VARS_THEME_STYLE, {
        'getProductStandardAjax': cartStandardAjaxUrl,
        'isSubscriptionCart': isSubscriptionCart == 1,
    });
    productStandardToggle.bindEvents();

    // 兌換商品更改商品規格
    const exchangeProductStandardToggle = new ExchangeProductStandardToggle(cart_detail_area, mobileProductStandardPushDom, JS_VARS_THEME_STYLE, {
        'getProductStandardAjax': cartExchangeStandardAjaxUrl,
    });
    exchangeProductStandardToggle.bindEvents();

    // 服務商品更改預約時段
    const reservableProductEventToggle = new ReservableProductEventToggle(cart_detail_area, mobileProductStandardPushDom, JS_VARS_THEME_STYLE);
    reservableProductEventToggle.bindEvents();

    // 更改組合商品組數
    cart_detail_area.on('change', '.js_cart_list_bundle_quantity', function () {
        var quantity = $(this).val(),
            bundle_id = $(this).attr('data-bundle-id'),
            bundleDisplay = $('#cart_bundle_sales_' + bundle_id).prop('checked');

        var params = getParams();
        params.bundle_id = bundle_id;
        params.quantity = quantity;

        const action = 'update_bundle_items';
        setCartItem(action, params, function (data) {
            if (data.status) {
                recordUserEventTrack(checkoutPageChangeBundleItemQuantity, getCartAjaxUrl(action), {
                    'quantity': Number(quantity),
                });
            }

            shippingCostDisplay(data);
            $('#cart_bundle_sales_' + bundle_id).prop('checked', bundleDisplay);
            setCartBundleItemStyle('cart_bundle_sales_' + bundle_id);
        });
    });

    // 刪除商品
    cart_detail_area.on('click', '.js_cart_list_del_item', function (event) {
        event.preventDefault();

        const addprice_element = $(this).closest('.js_cart_item_list ').find('.item_addproduct');
        const isLiveShopping168 = $(this).data('is-liveshopping168') == 1;
        const isReservable = $(this).data('is-reservable') === 1;
        const productId = $(this).attr('data-product-id');

        let i = 0;
        let params = getParams();
        params.standard_id = $(this).attr('data-standard-id');
        params.qty = $(this).attr('data-qty');
        params.removeItemAddprices = 'n';
        params.add_add_prices = {};

        const deleteCartItemAction = () => {
            if (addprice_element.length > 0) {
                params['removeItemAddprices'] = 'y';
                addprice_element.each(function () {

                    var add_price_id = $(this).find('.js_cart_list_add_price_quantity').attr('data-add-price-id'),
                        add_price_standard_id = $(this).find('.js_cart_list_add_price_quantity').attr('data-add-price-standard-id'),
                        qty = $(this).find('.js_cart_list_add_price_quantity').attr('data-origin-qty');

                    params['add_add_prices'][i] = {
                        id: add_price_id,
                        standard_id: add_price_standard_id,
                        quantity: qty
                    };
                    i++;

                })

            }

            if ($(this).data('is-ticket') == 1) {

                ticket_count--;

            }

            var shipping_id = $('#shipping').val(),
                is_date_active = 0;

            if (shipping_id == 211) {

                is_date_active = $('#store_name option:selected').attr('data-date-active');

            } else if (shipping_id == 231) {
                is_date_active = $('#int_receiver_country option:selected').attr('data-date-active');
            }

            if (isReservable) {
                params.date = $(this).data('date');
                params.reservable_products_events_id = $(this).data('reservable-products-events-id');

                const action = 'remove_reservable_item';
                let setCartItemCallback = (response) => {
                    if (response.status) {
                        recordUserEventTrack(checkoutPageDeleteProductItem, getCartAjaxUrl(action), {
                            'product_id': Number(productId),
                            'standard_id': Number(params.standard_id),
                            'quantity': Number(params.qty),
                        });
                    }

                    let cartIdToken = $(this).data('cart-id');
                    ProductCustomFieldDataStorage.deleteStorage(ProductCustomFieldDataStorage.getStorageCacheKey(cartIdToken));
                    ProductFormValidateActionState.deleteState(ProductFormValidateActionState.getStorageCacheKey(cartIdToken));
                    shippingCostDisplay(response);
                    getProductCustomFieldsAndRefreshRender({
                        url: productCustomFieldsUrl,
                        isMobile: typeof is_mobile !== 'undefined' && is_mobile === 1
                    });
                }
                setCartItem(action, params, setCartItemCallback);
            } else {
                const action = 'remove_cart_item';
                setCartItem(action, params, function (response) {
                    if (response.status) {
                        recordUserEventTrack(checkoutPageDeleteProductItem, getCartAjaxUrl(action), {
                            'product_id': Number(productId),
                            'standard_id': Number(params.standard_id),
                            'quantity': Number(params.qty),
                        });
                    }

                    shippingCostDisplay(response);
                });
            }
        };



        if (isLiveShopping168) {
            $.confirm({
                template: JconfirmTemplateHelper.getTemplate({
                    'templateType': '01',
                    'theme': 'el_confirm'
                }),
                columnClass: 'col-lg-5 col-xl-4',
                content: false,
                closeIcon: false,
                icon: 'icon-new_exclaim_circle',
                title: Lang.get('frontend.cart.liveShopping168.confirm.delete'),
                buttons: {
                    confirmButton: {
                        text: '<span class="el_text_inner">'+ Lang.get('frontend.other.btn.success') + '</span>',
                        btnClass: 'btn_confirm btn el_btn md solid el_rounded el_text m-0',
                        action: deleteCartItemAction
                    },
                    cancelButton: {
                        text: '<span class="el_text_inner">'+ Lang.get('frontend.other.btn.cancel') + '</span>',
                        btnClass: 'btn_cancel btn el_btn md solid el_rounded el_text m-0',
                    }
                },
                onOpenBefore: function() {
                    this.$el.find('.btn_confirm').attr('style', JS_VARS_THEME_STYLE.confirmButtonStyle);
                    this.$el.find('.btn_confirm').data('style', JS_VARS_THEME_STYLE.confirmButtonStyle);
                    this.$el.find('.btn_confirm').data('hover-style', JS_VARS_THEME_STYLE.confirmButtonHoverStyle);

                    this.$el.find('.btn_cancel').attr('style', JS_VARS_THEME_STYLE.cancelButtonStyle);
                    this.$el.find('.btn_cancel').data('style', JS_VARS_THEME_STYLE.cancelButtonStyle);
                    this.$el.find('.btn_cancel').data('hover-style', JS_VARS_THEME_STYLE.cancelButtonHoverStyle);

                    this.$el.find('.btn_confirm, .btn_cancel').hover(
                        function () {
                            $(this).attr('style', $(this).data('hover-style'));
                        },
                        function () {
                            $(this).attr('style', $(this).data('style'));
                        }
                    );
                }
            });
        } else {
            deleteCartItemAction();
        }
    });

    // 刪除優惠券
    cart_detail_area.on('click', '.js_cart_list_del_coupon', function (event) {
        event.preventDefault();
        $('.js_coupon').val('');
        var params = getParams();
        setCartItem('set_coupon', params, shippingCostDisplay);
    });


    // 刪除兌換商品
    cart_detail_area.on('click', '.js_cart_exchange_list_del_item', function (event) {
        event.preventDefault();
        const productId = $(this).attr('data-product-id');
        var params = getParams();
        params.standard_id = $(this).attr('data-standard-id');
        params.qty = $(this).attr('data-qty');
        const action = 'remove_exchange_item';
        setCartItem(action, params, function (response) {
            if (response.status) {
                recordUserEventTrack(checkoutPageDeleteExchangeItem, getCartAjaxUrl(action), {
                    'product_id': Number(productId),
                    'standard_id': Number(params.standard_id),
                    'quantity': Number(params.qty),
                });
            }

            shippingCostDisplay(response);
        });
    });

    // 刪除組合商品
    cart_detail_area.on('click', '.js_cart_list_del_bundle_item', function (event) {
        event.preventDefault();

        var params = getParams();
        params.bundle_id = $(this).attr('data-bundle-id');
        const action = 'remove_bundle_items';
        setCartItem(action, params, function (response) {
            if (response.status) {
                recordUserEventTrack(checkoutPageDeleteBundleItem, getCartAjaxUrl(action));
            }
            shippingCostDisplay(response);
        });
    });

    // 開啟組合商品明細
    cart_detail_area.on('change', 'input[name="cart_bundle_sales"]', function () {
        setCartBundleItemStyle($(this).attr('id'));
    });

    // 更改加價購數量
    cart_detail_area.on('change', '.js_cart_list_add_price_quantity', function () {
        let qty = $(this).val(),
            product_id = $(this).attr('data-product-id'),
            standard_id = $(this).attr('data-standard-id'),
            add_price_id = $(this).attr('data-add-price-id'),
            add_price_limit_qty = $(this).attr('data-add-price-qty-limit'),
            add_price_standard_id = $(this).attr('data-add-price-standard-id'),
            is_reservable = $(this).attr('data-is-reservable');

        let main_qty = count_main_product_qty(standard_id);
        let add_price_qty = count_add_price_qty(standard_id);
        let add_price_qty_limit = $(this).closest('.js_cart_item_list').find('.add_price_qty_limit').val();
        let reservableProductsEventsId = $(this).data('reservable-products-events-id');
        let date = $(this).data('date');

        let params = getParams();
        params.qty = qty;
        params.standard_id = standard_id;
        params.add_price_id = add_price_id;
        params.add_price_standard_id = add_price_standard_id;
        params.reservable_products_events_id = reservableProductsEventsId;
        params.date = date;
        params.mainQty = main_qty;

        if(is_reservable === '1'){
            if (!checkReservationAddPriceQuantityByStandardId(standard_id, add_price_standard_id)) {
                refreshSelectorSyncSpan();
                return false;
            }
            const action = 'add_reservable_add_price_item';
            setCartItem(action, params, function(response) {
                if (response.status) {
                    recordUserEventTrack(checkoutPageChangeAddPriceItemQuantity, getCartAjaxUrl(action), {
                        'parent_product_id': Number(product_id),
                        'parent_standard_id': Number(standard_id),
                        'product_id': Number(add_price_id),
                        'standard_id': Number(add_price_standard_id),
                        'quantity': Number(qty),
                    });
                }

                shippingCostDisplay(response);
            });
        }else{
            if (!checkRetailAddPriceQuantityByStandardId(standard_id)) {
                $(this).val($(this).attr('data-origin-qty'));
                refreshSelectorSyncSpan();
                return false;
            }
            const action = 'add_add_price_item';
            setCartItem(action, params, function(response) {
                if (response.status) {
                    recordUserEventTrack(checkoutPageChangeAddPriceItemQuantity, getCartAjaxUrl(action), {
                        'parent_product_id': Number(product_id),
                        'parent_standard_id': Number(standard_id),
                        'product_id': Number(add_price_id),
                        'standard_id': Number(add_price_standard_id),
                        'quantity': Number(qty),
                    });
                }

                shippingCostDisplay(response);
            });
        }
        $('.js_cart_list_del_add_price[data-standard-id=' + standard_id + '][data-add-price-id=' + add_price_id + '][data-add-price-standard-id=' + add_price_standard_id + ']').val(qty);
    });

    // 刪除加價購
    cart_detail_area.on('click', '.js_cart_list_del_add_price', function (event) {
        event.preventDefault();

        const productId = $(this).attr('data-product-id');
        var params = getParams();
        params.standard_id = $(this).attr('data-standard-id');
        params.add_price_id = $(this).attr('data-add-price-id');
        params.add_price_standard_id = $(this).attr('data-add-price-standard-id');
        params.qty = $(this).attr('data-add-price-qty');
        params.reservable_products_events_id = $(this).data('reservable-products-events-id');
        params.date = $(this).data('date');

        if(typeof $(this).data('reservable-products-events-id') === 'undefined'){
            const action = 'remove_add_price_item';
            setCartItem(action, params, function (response) {
                if (response.status) {
                    recordUserEventTrack(checkoutPageDeleteAddPriceItem, getCartAjaxUrl(action), {
                        'parent_product_id': Number(productId),
                        'parent_standard_id': Number(params.standard_id),
                        'product_id': Number(params.add_price_id),
                        'standard_id': Number(params.add_price_standard_id),
                        'quantity': Number(params.qty),
                    });
                }

                shippingCostDisplay(response);
            });
        }else{
            const action = 'remove_reservable_add_price_item';
            setCartItem(action, params, function (response) {
                if (response.status) {
                    recordUserEventTrack(checkoutPageDeleteAddPriceItem, getCartAjaxUrl(action), {
                        'parent_product_id': Number(productId),
                        'parent_standard_id': Number(params.standard_id),
                        'product_id': Number(params.add_price_id),
                        'standard_id': Number(params.add_price_standard_id),
                        'quantity': Number(params.qty),
                    });
                }

                shippingCostDisplay(response);
            });
        }
    });

    // 更改滿額購數量
    cart_detail_area.on('change', '.js_cart_add_price_quantity', function () {
        var qty = $(this).val(),
            standard_id = $(this).attr('data-standard-id');
        const productId = $(this).attr('data-product-id');

        var params = getParams();
        params.qty = qty;
        params.standard_id = standard_id;
        const action = 'update_cart_add_prices';
        setCartItem(action, params, function(response) {
            if (response.status) {
                recordUserEventTrack(checkoutPageChangeCartAddPriceItemQuantity, getCartAjaxUrl(action), {
                    'product_id': Number(productId),
                    'standard_id': Number(params.standard_id),
                    'quantity': Number(params.qty),
                });
            }
            shippingCostDisplay(response);
        });
        $('.js_cart_list_del_item[data-standard-id=' + standard_id + ']').attr('data-qty', qty);
    });

    // 更改兌換數量
    cart_detail_area.on('change', '.js_cart_exchange_quantity', function () {
        let qty = $(this).val();
        let productId = $(this).attr('data-product-id');
        let standardId = $(this).attr('data-standard-id');
        let originQty = $(this).data('origin-qty');

        let params = getParams();
        params.qty = qty;
        params.standard_id = standardId;
        const action = 'update_exchange_item_quantity';
        setCartItem(action, params, function(response){
            if (response.status) {
                recordUserEventTrack(checkoutPageChangeExchangeItemQuantity, getCartAjaxUrl(action), {
                    'product_id': Number(productId),
                    'standard_id': Number(standardId),
                    'quantity': Number(qty),
                });
            }

            shippingCostDisplay(response);
        });
    });

    // 選擇贈品
    cart_detail_area.on('change', '.js_gift_select', function () {
        var productId = $(this).val();
        const standardId = $(this).find('option:selected').data('standard-id') || 0;
        var giftId = $(this).closest('.js_cart_list_gift').data('gift-id');

        var params = getParams();
        params.productId = productId;
        params.giftId = giftId;

        const action = 'update_gift';
        setCartItem(action, params, function(response) {
            if (response.status && productId > 0) {
                recordUserEventTrack(checkoutPageSelectGift, getCartAjaxUrl(action), {
                    'product_id': Number(productId),
                    'standard_id': Number(standardId),
                });
            }

            shippingCostDisplay(response);
        });
    });

    // 更改租賃服務數量
    cart_detail_area.on('change', '.js_cart_list_rentable_quantity', function(){
        const rentableCartItemDom = $(this).closest('.js_rentable_cart_item');
        const itemId = rentableCartItemDom.attr('data-item-id');
        const product_id = rentableCartItemDom.attr('data-product-id');
        const standard_id = rentableCartItemDom.attr('data-standard-id');
        const quantity = $(this).val();
        const originalQty = rentableCartItemDom.attr('data-quantity');

        let params = $.extend({}, getParams(), {
            standard_id: standard_id,
            rentable_start_timestamp_ms: rentableCartItemDom.data('rentable-start-at'),
            rentable_end_timestamp_ms: rentableCartItemDom.data('rentable-end-at'),
            rentable_unit: rentableCartItemDom.data('rentable-unit'),
            quantity: quantity,
        });

        const action = UPDATE_RENTABLE_QUANTITY;

        let checkRentableAddPriceQuantity = true;
        cart_detail_area.find('.js_rentable_add_price_item[data-main-item-id=' + itemId + ']').each(function(){
            const rentableAddPriceItemDom = $(this);
            const addPriceQty = rentableAddPriceItemDom.data('add-price-qty');
            const mainQty = quantity;
            const addPriceCondition = rentableAddPriceItemDom.data('purchase-condition');
            const addPriceMaxLimit = rentableAddPriceItemDom.data('max-limit');

            let {'status': checkStatus, 'errorMessage': errorMessage} = checkRentableAddPriceQuantityByStandardId(mainQty, addPriceQty, addPriceCondition, addPriceMaxLimit);

            if (! checkStatus) {
                new DialogMessage({
                    'title': errorMessage,
                }).handle();

                checkRentableAddPriceQuantity = false;
                return false;
            }
        });

        if (! checkRentableAddPriceQuantity) {
            $(this).val(originalQty);
            selectorSyncSpan($(this));
            return;
        }

        let setCartItemCallBack = (response) => {
            if (response.status) {
                recordUserEventTrack(checkoutPageChangeProductItemQuantity, getCartAjaxUrl(action), {
                    'product_id': Number(product_id),
                    'standard_id': Number(standard_id),
                    'quantity': Number(quantity),
                });
            }

            shippingCostDisplay(response);
        }
        setCartItem(action, params, setCartItemCallBack);
    });

    // 更改租賃服務加購品數量
    cart_detail_area.on('change', '.js_cart_list_rentable_add_price_quantity', function(){

        const rentableAddPriceItemDom = $(this).closest('.js_rentable_add_price_item');
        const add_price_id = rentableAddPriceItemDom.attr('data-add-price-id');
        const add_price_standard_id = rentableAddPriceItemDom.attr('data-add-price-standard-id');
        const addPriceQty = $(this).val();
        const addPriceOriginalQty = rentableAddPriceItemDom.data('add-price-qty');
        const standard_id = rentableAddPriceItemDom.attr('data-standard-id');
        const product_id = rentableAddPriceItemDom.attr('data-product-id');
        const rentableStartTimestampMs = rentableAddPriceItemDom.data('rentable-start-at');
        const rentableEndTimestampMs = rentableAddPriceItemDom.data('rentable-end-at');
        const rentableUnit = rentableAddPriceItemDom.data('rentable-unit');
        const mainQty = rentableAddPriceItemDom.attr('data-origin-qty');
        const addPriceCondition = rentableAddPriceItemDom.data('purchase-condition');
        const addPriceMaxLimit = rentableAddPriceItemDom.data('max-limit');

        let params = $.extend({}, getParams(), {
            product_id: product_id,
            standard_id: standard_id,
            mainQuantity: mainQty,
            add_price_id: add_price_id,
            add_price_standard_id: add_price_standard_id,
            rentable_start_timestamp_ms: rentableStartTimestampMs,
            rentable_end_timestamp_ms: rentableEndTimestampMs,
            rentable_unit: rentableUnit,
            quantity: addPriceQty,
        });

        let {'status': checkStatus, 'errorMessage': errorMessage} = checkRentableAddPriceQuantityByStandardId(mainQty, addPriceQty, addPriceCondition, addPriceMaxLimit);

        if (! checkStatus) {
            $(this).val(addPriceOriginalQty);
            selectorSyncSpan($(this));

            new DialogMessage({
                'title': errorMessage,
            }).handle();
            return;
        }

        const action = ADD_RENTABLE_ADDPIRCE_ITEM;
        setCartItem(action, params, function (response) {
            if (response.status) {
                recordUserEventTrack(checkoutPageChangeAddPriceItemQuantity, getCartAjaxUrl(action), {
                    'parent_product_id': Number(product_id),
                    'parent_standard_id': Number(standard_id),
                    'product_id': Number(add_price_id),
                    'standard_id': Number(add_price_standard_id),
                    'quantity': Number(addPriceQty),
                });
            }

            shippingCostDisplay(response);
        });
    });

    // 刪除租賃服務
    cart_detail_area.on('click', '.js_cart_list_delete_rentable_item', function(){
        const rentableCartItemDom = $(this).closest('.js_rentable_cart_item');
        const product_id = rentableCartItemDom.attr('data-product-id');
        const standard_id = rentableCartItemDom.attr('data-standard-id');
        const qty = rentableCartItemDom.attr('data-quantity');

        let params = $.extend({}, getParams(), {
            standard_id: standard_id,
            rentable_start_timestamp_ms: rentableCartItemDom.data('rentable-start-at'),
            rentable_end_timestamp_ms: rentableCartItemDom.data('rentable-end-at'),
            rentable_unit: rentableCartItemDom.data('rentable-unit'),
            qty: qty,
        });

        const action = REMOVE_RENTABLE_ITEM;
        let setCartItemCallBack = (response) => {
            if (response.status) {
                recordUserEventTrack(checkoutPageDeleteProductItem, getCartAjaxUrl(action), {
                    'product_id': Number(product_id),
                    'standard_id': Number(standard_id),
                    'quantity': Number(qty),
                });
            }

            shippingCostDisplay(response);
        }
        setCartItem(action, params, setCartItemCallBack);
    });

    // 刪除租賃服務加購品
    cart_detail_area.on('click', '.js_cart_list_del_rentable_add_price', function(){
        const rentableAddPriceItemDom = $(this).closest('.js_rentable_add_price_item');
        const add_price_id = rentableAddPriceItemDom.attr('data-add-price-id');
        const add_price_standard_id = rentableAddPriceItemDom.attr('data-add-price-standard-id');
        const qty = rentableAddPriceItemDom.attr('data-add-price-qty');
        const standard_id = rentableAddPriceItemDom.attr('data-standard-id');
        const product_id = rentableAddPriceItemDom.attr('data-product-id');
        const rentableStartTimestampMs = rentableAddPriceItemDom.data('rentable-start-at');
        const rentableEndTimestampMs = rentableAddPriceItemDom.data('rentable-end-at');
        const rentableUnit = rentableAddPriceItemDom.data('rentable-unit');

        let params = $.extend({}, getParams(), {
            standard_id: standard_id,
            add_price_id: add_price_id,
            add_price_standard_id: add_price_standard_id,
            rentable_start_timestamp_ms: rentableStartTimestampMs,
            rentable_end_timestamp_ms: rentableEndTimestampMs,
            rentable_unit: rentableUnit,
            qty: qty,
        });

        const action = REMOVE_RENTABLE_ADDPRICE_ITEM;
        setCartItem(action, params, function (response) {
            if (response.status) {
                recordUserEventTrack(checkoutPageDeleteAddPriceItem, getCartAjaxUrl(action), {
                    'parent_product_id': Number(product_id),
                    'parent_standard_id': Number(standard_id),
                    'product_id': Number(add_price_id),
                    'standard_id': Number(add_price_standard_id),
                    'quantity': Number(qty),
                });
            }

            shippingCostDisplay(response);
        });
    });

    // coupon有效與否檢查
    cart_detail_area.on('change', '.js_coupon', function () {
        var params = getParams();
        setCartItem('set_coupon', params, shippingCostDisplay);
    });

    cart_detail_area.on('change', '.js_redeem_discount', function () {
        var params = getParams();
        setCartItem('set_redeem_discount', params, shippingCostDisplay);
    });

    // 顯示商品詳細資料(lightbox)
    cart_detail_area.on('click', '.js_product_detail_lightbox', function (e) {
        var self = $(this);
        var productType = self.data('product-source');
        var productId = self.data('product-id');
        var standardId = self.data('product-standard-id');

        var url = '';

        switch (productType) {
            case 'cartAddPrice':
                url = cart_addprice_detail_url + '/' + productId + '/' + standardId;
                break;
            case 'addPrice':
                url = addprice_detail_url + '/' + productId + '/' + standardId;
                break;
            default:
                url = '';
                break;
        }

        if (url == '') {
            return;
        }

        $.confirm({
            template: JconfirmTemplateHelper.getTemplate({
                'templateType': '01',
                'theme': 'el_confirm'
            }),
            columnClass: 'col-md-10',
            closeIcon: false,
            icon: '',
            title: false,
            content: 'URL:' + url,
            offsetTop: 0,
            offsetBottom: 0,
            buttons: {
                cancelButton: {
                    keys: ['esc'],
                    text: '<span class="el_text_inner">' + Lang.get('frontend.other.btn.close') + '</span>',
                    btnClass: 'js_cancel btn_md btn_cancel btn el_btn md solid el_rounded el_text m-0'
                }
            },
            onOpenBefore: function () {
                this.$el.find('.btn_cancel').attr('style', JS_VARS_THEME_STYLE.cancelButtonStyle);
                this.$el.find('.btn_cancel').data('style', JS_VARS_THEME_STYLE.cancelButtonStyle);
                this.$el.find('.btn_cancel').data('hover-style', JS_VARS_THEME_STYLE.cancelButtonHoverStyle);

                this.$el.find('.btn_cancel').hover(
                    function () {
                        $(this).attr('style', $(this).data('hover-style'));
                    },
                    function () {
                        $(this).attr('style', $(this).data('style'));
                    }
                );
            },
            contentLoaded: function (data, status, xhr) {
                if (data == 'error') {
                    new DialogMessage({
                        title: Lang.get('frontend.errormsg.cart.product.loadingerror'),
                    }, {
                        'closeTimeout': 1200
                    }).handle();

                    this.close();
                    return false;
                } else {
                    this.setContent(data);
                }
            },
        });
    });

    // 訂閱購選擇
    cart_detail_area.on('change', '.js_select_subscribe', function (event) {
        event.preventDefault();

        if ($(this).val() == '2') {
            $('.js_num_periods').removeClass('d-none');
            $('.js_agree_auto_subscription_area').addClass('d-none');
        } else {
            $('.js_num_periods').addClass('d-none');
            $('.js_agree_auto_subscription_area').removeClass('d-none');
        }

        setCartItem('set_shipping', getParams(), shippingCostDisplay, true);
    });

    // 週期訂閱，選擇購買期數
    cart_detail_area.on('change', '#js_subscription_cycle_times', function (event) {
        event.preventDefault();
        setCartItem('set_shipping', getParams(), shippingCostDisplay, true);
    });

    /**
     * 初始化 訂閱購同意區塊
     */
    $('.js_select_subscribe').trigger('change')

    //結帳頁登入
    if (!isReservable) {
        if ($("#order_fileds").is(":hidden") && $('#shipping').val() !== 'none') {
            $(".js_customer_nologin").addClass('active');
            $("#order_fileds").removeClass("d-none");
        }
    }

    /**
     * 超取時要紀錄 cookie
     */
    var setBuyerCookie = function (callback) {
        var orders = {};
        orders.purchaser_name = document.getElementsByName("orders[purchaser_name]")[0].value;
        orders.purchaser_phone = document.getElementsByName("orders[purchaser_phone]")[0].value;
        orders.purchaser_email = document.getElementsByName("orders[purchaser_email]")[0].value;
        orders.customer_memo = document.getElementsByName("orders[customer_memo]")[0].value;
        orders.shipping = document.getElementsByName("orders[shipping]")[0].value;
        orders.payment = document.getElementsByName("orders[payment]")[0].value;
        orders.recipient_id = recipient_selected_data.get() === null ? 0 : recipient_selected_data.get().id;
        orders.recipient_type = recipient_selected_data.getType() === null ? '' : recipient_selected_data.getType();
        orders.int_receiver_country = document.getElementsByName("orders[int_receiver_country]")[0].value;
        orders.int_receiver_address = document.getElementsByName("orders[int_receiver_address]")[0].value;
        orders.int_receiver_city = document.getElementsByName("orders[int_receiver_city]")[0].value;
        orders.int_receiver_city_name = $('#js_receiver_city').val() || $('#receiver_city').val();
        orders.int_receiver_district = document.getElementsByName("orders[int_receiver_district]")[0].value;
        orders.int_receiver_district_name = $('#js_receiver_region').val() || $('#receiver_region').val();
        orders.int_receiver_zip = document.getElementsByName("orders[int_receiver_zip]")[0].value;

        if (['371', '385', '421'].includes(orders.payment)) {
            orders = get_card_staging(orders);
        }

        if (JS_VARS.hasInstall.InvoiceAddons) {
            orders = set_order_invoice_info(orders);
        }

        if (typeof document.getElementsByName("want_edm")[0] != 'undefined') {
            orders.want_edm = document.getElementsByName("want_edm")[0].checked;
        } else {
            orders.want_edm = true;
        }

        orders.same_purchaser = document.getElementsByName("same_purchaser")[0].checked ? 1 : 0;
        orders.receiver_name = document.getElementsByName("orders[receiver_name]")[0].value;
        orders.receiver_phone = document.getElementsByName("orders[receiver_phone]")[0].value;

        if (orders.same_purchaser) {
            orders.receiver_phone = orders.receiver_name = '';
        }

        // 自訂欄位
        orders.customQuestion = ShippingCustomFields.method.getCustomFields();
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: 'cart/set-buyer-info-cookie',
            data: {buyerInfo: orders},
            complete: callback
        });
    };

    var set_order_invoice_info = function (orders) {
        var orders_invoice = document.getElementsByName("orders_invoice[type]");
        if (!orders_invoice.length) {
            return orders;
        }

        orders.invoice_type = orders_invoice[0].value;

        if (orders.invoice_type != null) {
            switch (orders.invoice_type) {
                // 個人電子發票
                case '1':
                    orders.invoice_carrier_type = document.getElementsByName("orders_invoice[carrier_type]")[0].value;
                    orders.electronic_return = ($('#electronic_return').prop('checked')) ? '1' : '0';
                    break;
                // 公司用
                case '2':
                    orders.invoice_company_title = document.getElementsByName("orders_invoice[company_title]")[0].value;
                    orders.invoice_company_uid = document.getElementsByName("orders_invoice[company_uid]")[0].value;
                    break;
                // 電子發票捐贈
                case '3':
                    orders.invoice_lovecode = document.getElementsByName("orders_invoice[lovecode]")[0].value;
                    orders.electronic_return = ($('#electronic_return').prop('checked')) ? '1' : '0';
                    break;
            }

            if (orders.invoice_carrier_type != 4) {
                switch (orders.invoice_carrier_type) {
                    // 手機條碼
                    case '0':
                        orders.orders_invoice_no_mobile = $('#carrier_no_mobile').val();
                        orders.carrier_no_mobile = $('#carrier_no_mobile_confirm').val();
                        break;
                    // 自然人憑證
                    case '1':
                        orders.orders_invoice_no_nature = $('#carrier_no_nature').val();
                        orders.carrier_no_nature = $('#carrier_no_nature_confirm').val();
                        break;
                    // 悠遊卡
                    case '3':
                        orders.orders_invoice_no_easycard = $('#carrier_no_easycard').val();
                        orders.carrier_no_easycard = $('#carrier_no_easycard_confirm').val();
                        break;
                }
            }
        }

        return orders;
    }

    var showOrderfields = function () {
        var el_order_fields = $("#order_fileds");
        var el_body_html = $("body, html");
        if (el_order_fields.is(":hidden")) {
            el_order_fields.addClass("active");
            $("#order_fileds").removeClass("d-none").hide().fadeIn();
            el_body_html.animate({
                scrollTop: el_order_fields.offset().top - 10
            }, 400);
        }
    };
    $(".js_customer_nologin").on("click", function () {

        showOrderfields();
        var userChooseShippingId = getUserChooseOrDefaultShipping();
        if (userChooseShippingId !== 0 && !$("#order_fileds").hasClass('d-none')) {
            $('#shipping').val(userChooseShippingId);
            setCartItem('set_shipping', getParams(), shippingCostDisplay);
            setPhonePlaceholder();
            setEmailPlaceholder();
            setNameMaxlength();

            if (userChooseShippingId == '211') {
                setStoreCode();
            }
        }
        $('.js_order_login_area').addClass('active');
        $(this).addClass('active');
    });

    $('#js_cart_detail_area').on("click", ".js_member_info_pop", function () {
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: levelDescriptionUrl,
            success: function (result) {
                $.confirm({
                    template: JconfirmTemplateHelper.getTemplate({
                        'templateType': '01',
                        'theme': 'el_confirm el_popup_shopping_info'
                    }),
                    columnClass: 'col-md-10',
                    closeIcon: false,
                    icon: '',
                    title: false,
                    backgroundDismiss: true,
                    draggable: false,
                    offsetTop: 0,
                    offsetBottom: 0,
                    buttons: {
                        cancelButton: {
                            keys: ['esc'],
                            text: '<span class="el_text_inner">' + Lang.get('frontend.cart.after_sales_service.btn.success') + '</span>',
                            btnClass: 'btn_confirm btn el_btn md solid el_rounded el_text m-0',
                        }
                    },
                    onOpenBefore: function () {
                        this.setContent('<header class="title_area mt-0"><hgroup class="title_content d-flex justify-content-between align-items-center"><h4 class="main_title">會員權益說明</h4></hgroup><hr class="main_hr"></header><article class="el_popup_content inner_layout">' + result + '</article>');
                    }
                });
            }
        });

    });

    // 選擇運送方式
    $('#shipping').change(function () {

        let selectedShipping = $(this).val();
        ShippingCustomFields.method.fill(selectedShipping);
        ShippingCustomFields.method.switchDisplay();

        checkShippingForTwIslands();

        $('#payment').prop('disabled', true);
        $('#payment option[value="none"]').attr('selected', true);
        $('#shipping_time').attr('name', '');
        $('#shipping_receipt_at').attr('name', '');

        const action = 'set_shipping';
        setCartItem(action, getParams(), function (response) {
            if (response.status && selectedShipping !== 'none' && selectedShipping !== '') {
                recordUserEventTrack(checkoutPageSelectShipping, getCartAjaxUrl(action), {
                    'shipping_id': String(selectedShipping),
                });
            }
            shippingCostDisplay(response);
        });
        refreshOrderFields();
        setPhonePlaceholder();
        setEmailPlaceholder();
        setNameMaxlength();

        $('.js_allpay_code, .js_allpay_name, .js_allpay_address').text(Lang.get('frontend.cart.shipping.allpay.none'));
        $('#CVSStoreID, #CVSStoreName, #js_allpay_address').val('');
        $('.js_ezship_system, .js_ezship_name, .js_ezship_code, .js_ezship_address').val('');
        $('.js_ezship_system, .js_ezship_name, .js_ezship_code, .js_ezship_address').text(Lang.get('frontend.cart.shipping.allpay.none'));
        $('#PayNowStoreID, #PayNowStoreName, #PayNowStoreAddress, #PayNowStoreService, #PayNowStoreReservedNo, #PayNowStoreShipDate').val('');
        $('.js_paynow_storeID, .js_paynow_storeName, .js_paynow_storeAddress').text(Lang.get('frontend.cart.shipping.allpay.none'));

        $('#GoodDealStoreID, #GoodDealStoreName, #GoodDealStoreAddress').val('');
        $('.js_gooddeal_storeID, .js_gooddeal_storeName, .js_gooddeal_storeAddress').text(Lang.get('frontend.cart.shipping.gooddeal.none'));

        $('#shipping_date').val("");

        //紀錄使用者Shipping 用於判斷Default 用
        setUserChooseShipping($(this).val());
    });

    // 選擇付款方式
    $('#payment').on('change', function () {
        var payment_id = $(this).val(),
            payment_installment = '';

        refreshPaymentFields();

        if (payment_id == 385) {
            payment_installment = $('#ecpay_installment').val();
        } else if (payment_id == 371) {
            payment_installment = $('#pay2go_installment').val();
        } else if (payment_id == 421) {
            payment_installment = $('#zingala_installment').val();
        }

        paymentButton();

        var params = getParams();
        params.payment_id = payment_id;
        params.payment_installment = payment_installment;

        const action = 'set_shipping';
        setCartItem(action, params, function (response) {
            if (response.status && payment_id !== 'none' && payment_id !== '') {
                recordUserEventTrack(checkoutPageSelectPayment, getCartAjaxUrl(action), {
                    'payment_id': String(payment_id),
                });
            }

            paymentAdditionalDisplay(response);
        });
        setPhonePlaceholder();
        setEmailPlaceholder();

        setCradPaymentArea(payment_id);

        //紀錄使用者Payment 用於判斷 Default 用
        setUserChoosePayment(payment_id);
    });

    // 選擇信用卡分期
    $("#pay2go_installment, #ecpay_installment, #zingala_installment").on('change', function () {
        var params = getParams();
        params.payment_id = $('#payment').val();
        params.payment_installment = $(this).val();

        setCartItem('set_shipping', params, paymentAdditionalDisplay);
        setCradPaymentArea($('#payment').val());
    });

    // 鄉鎮市選擇
    $('#local_address_area').on('change', '.js_receiver_district', function () {
        if (!$('#local_address_area').hasClass('d-none')) {
            $('#payment option[value="none"]').attr('selected', true);
            setCartItem('set_shipping', getParams(), shippingCostDisplay);

            checkShippingForTwIslands();
        }
    });

    // 訂閱購，配送單位
    $('#js_subscription_cycle').change(function () {
        var cycle = $(this).val();
        if (cycle <= 6) {
            $('.js_hope_receipt_at').closest('.js_subscription_area').addClass('d-none');
        } else {
            $('.js_hope_receipt_at').closest('.js_subscription_area').removeClass('d-none');
            hopeReceiptAt();
        }
    });

    function hopeReceiptAt() {
        var cycle = $('#js_subscription_cycle').val();
        var cycleList = [];
        var cycleOption = '<option value="">-' + Lang.get('frontend.cart.subscription.note.select') + '-</option>';
        if (cycle >= 7 && cycle <= 21) {
            cycleList = JS_VARS.weeksCycle;
        } else if (cycle >= 30) {
            cycleList = JS_VARS.monthsCycle;
        }

        Object.keys(cycleList).forEach(function (itemKey, itemValue) {
            cycleOption += '<option value="' + itemKey + '">' + cycleList[itemKey] + '</option>';
        });
        $('.js_hope_receipt_at').html(cycleOption);
        $('.js_hope_receipt_at').trigger('change');
        refreshSelectorSyncSpan();
    }

    function internationalShipping() {
        var country = $('#int_receiver_country').val(),
            ssiID = $('#int_receiver_country').find(':selected').data('ssiid');

        ShippingCustomFields.method.fill('231_' + ssiID);
        ShippingCustomFields.method.switchDisplay()

        $.each(shipping_options[231]['setting'], function (key, val) {

            if (val.country == country && val.id == ssiID) {

                if (typeof val.description != 'undefined' && val.description != '') {
                    $('#js_shipping_description_area').removeClass('d-none');
                    $('#js_shipping_description').text(val.description);
                }

                if (typeof val.date != 'undefined' && val.date == '1') {
                    if (typeof val.date_is_require != "undefined" &&
                        val.date_is_require == "1") {
                        $('#js_shipping_date_area').removeClass('d-none');
                    }
                    if (is_product_pre_order_period_empty == '1') {
                        $('#js_shipping_date_area').removeClass('d-none');
                    }
                    $('#shipping_date').attr('name', 'orders[shipping_date_at]');

                    // 指定到貨日期天數
                    var minDate = getMinDate("231", val);
                    shippingDateAction('minDate', minDate);

                    if (typeof val.is_holiday_send != 'undefined' && val.is_holiday_send == '1') {
                        shippingDateAction('daysOfWeekDisabled', [0]);
                    } else {
                        shippingDateAction('daysOfWeekDisabled', [0, 6]);
                    }
                    // 排除到貨日期
                    var exceptDate = getShopShippingExceptDate("231", val);
                    shippingDateAction('disabledDates', exceptDate);
                }

                if (typeof val.time != 'undefined' && val.time == '1') {
                    $('#js_shipping_area').removeClass('d-none');
                    $('#shipping_time').attr('name', 'shipping_info[231][time]');
                    setShippingTime(231);
                }

                if (typeof val.is_holiday_send != 'undefined' && val.is_holiday_send == '1') {
                    $('.js_is_holiday_send').removeClass('d-none');
                }

                // 物流公司
                $('#js_logistics').attr('name', 'shipping_info[231][logistics]').val(typeof val.logistics != 'undefined' ? val.logistics : '');
            }
        });
    }

    function paynowoverseaShipping() {
        let shipping = $('#shipping').val();
        let country = $('#int_receiver_country').val();
        let shopsShipping = shipping_options[shipping]['setting'];
        ShippingCustomFields.method.fill(shipping + '_' + country);
        ShippingCustomFields.method.switchDisplay();
        if (typeof shopsShipping[country] !== 'undefined') {
            if (typeof shopsShipping[country]['description'] != 'undefined' && shopsShipping[country]['description'] != '') {
                $('#js_shipping_description_area').removeClass('d-none');
                $('#js_shipping_description').text(shopsShipping[country]['description']);
            }
        }
    }

    // 收件國家選擇
    var oldcountry = buyer_info.int_receiver_country;
    $('#int_receiver_country').change(function () {
        setCartItem('set_shipping', getParams(), shippingCostDisplay);

        var shipping = $('#shipping').val();
        var country = $(this).val();

        // 更改國家時，要重選門市
        if (oldcountry != country) {
            $('#PayNowStoreID, #PayNowStoreName, #PayNowStoreAddress').val('');
            $('.js_paynow_storeID, .js_paynow_storeName, .js_paynow_storeAddress').html('');
        }
        oldcountry = country;

        // 運送說明顯示
        $('#js_shipping_description_area, #js_shipping_date_area, #js_shipping_area, .js_is_holiday_send').addClass('d-none');
        $('#shipping_date').attr('name', '');
        $('#shipping_time').attr('name', '');

        if (is_holiday_send == 1) {
            $("#is_holiday_send").prop('checked', true);
            $('#is_holiday_send_val').val(is_holiday_send);
        } else {
            $('#is_holiday_send').prop('checked', false);
            $('#is_holiday_send_val').val('-1');
        }

        if (shipping == '231') {
            internationalShipping();
        } else if (shipping == '417' || shipping == '418') {
            paynowoverseaShipping();
        }
        setPhonePlaceholder();
    });

    // 收件人同購買人資料
    $('#same_info').change(function () {
        setPhonePlaceholder();
        setNameMaxlength();
    });

    // 實體門市取貨
    $('#store_name').change(function () {
        var store_address = $(this).children('option:selected').attr('data-store-address'),
            store_code = $(this).children('option:selected').attr('data-code'),
            setting_key = $(this).children('option:selected').attr('data-setting-key');

        ShippingCustomFields.method.fill('211_' + setting_key);
        ShippingCustomFields.method.switchDisplay();

        $('.js_store_setting_key').val(setting_key);
        $('.js_store_address').text(store_address).val(store_address);
        $('#js_shipping_description_area').addClass('d-none');

        // 取貨時間
        if (typeof shipping_options[211]['setting'][setting_key]['time'] == "undefined" ||
            shipping_options[211]['setting'][setting_key]['time'] != "1") {
            $('#js_shipping_shop_area').addClass('d-none');
            $('#shipping_shop_time').attr('name', '');
            $('#shipping_shop_time').val($("#shipping_shop_time option:first").val());
            $('#shipping_shop_time').closest('.form_select_block').find('.js_select_bind').html($("#shipping_shop_time option:first").text());
        }

        // 取貨時間替換
        if (typeof shipping_options[211]['setting'][setting_key]['time'] != "undefined" ||
            shipping_options[211]['setting'][setting_key]['time'] == "1") {
            setStorePickupTime();
        }

        // 取貨日期
        if (typeof shipping_options[211]['setting'][setting_key]['date'] == "undefined" ||
            shipping_options[211]['setting'][setting_key]['date'] != "1") {
            $('#js_shipping_date_area').addClass('d-none');
            $('#shipping_date').val('');
        }

        var store_name = $(this).val();
        var name_key = 'name_' + lang;

        $.each(shipping_options[211]['setting'], function (key, val) {
            if (val[name_key] == store_name) {

                if (typeof val.description != 'undefined' && val.description != '') {
                    $('#js_shipping_description_area').removeClass('d-none');
                    $('#js_shipping_description').text(val.description);
                }

                // 指定到貨時間
                if (typeof val.time != 'undefined' && val.time == '1') {
                    $('#js_shipping_shop_area').removeClass('d-none');
                    $('#shipping_shop_time').attr('name', 'shipping_info[211][time]');
                }

                // 指定到貨日期
                if (typeof val.date != 'undefined' && val.date == '1') {
                    if (typeof val.date_is_require != "undefined" &&
                        val.date_is_require == "1") {
                        $('#js_shipping_date_area').removeClass('d-none');
                    }
                    if (is_product_pre_order_period_empty == 1) {
                        $('#js_shipping_date_area').removeClass('d-none');
                    }

                    //實體門市更動時，清空指定到貨日期
                    $('#shipping_date').val('');
                    $('#shipping_date').attr('name', 'orders[shipping_date_at]');
                    $('#shipping_date').attr('placeholder', Lang.get('frontend.product.option.select') + ' ' + Lang.get('frontend.order.title.shop_date_select'));
                    $('#js_shipping_date_area .help_block span').html(Lang.get('frontend.errormsg.cart.shop_date'));

                    // 指定到貨日期天數
                    var minDate = getMinDate("211", val);
                    shippingDateAction('minDate', minDate);

                    if (typeof val.is_holiday_send != 'undefined' && val.is_holiday_send == '1') {
                        shippingDateAction('daysOfWeekDisabled', []);
                    } else {
                        shippingDateAction('daysOfWeekDisabled', [0, 6]);
                    }
                    // 排除到貨日期
                    var exceptDate = getShopShippingExceptDate("211", val);
                    shippingDateAction('disabledDates', exceptDate);
                }

            }
        });

        setStoreCode();

        var shipping_id = $('#shipping').val(),
            is_date_active = $('#store_name option:selected').attr('data-date-active');
        checkPreorderperiodExists(shipping_id, is_date_active, shippingDateShow);
    });

    // ezship 取貨超商選取
    $('#btn_ezship_store').click(function () {
        setBuyerCookie(function () {
            $('#ezship_form').remove();
            $('#js_map_area').append(ezshipMapForm);
            $('#ezship_form').trigger('submit');
        });
    });

    // 7-11超商取貨不付款
    $('#btn_7-11_store').click(function (event) {
        event.preventDefault();
        window.open('//emap.pcsc.com.tw/emap.aspx', '_blank');
    });

    // 結帳頁下方購物車明細點選 (手機版才有)
    $('.js_total_list_checkbox').click(function () {
        if ($(this).is(':checked')) {
            $.ajax({
                type: 'POST',
                dataType: 'json',
                url: total_list_url,
                success: function (result) {
                    $('.js_total_list').html(result);
                }
            });

        }
    });

    // 綠界超商取貨
    $('#btn_allpay_store').click(function () {

        if (typeof $('#allpayForm').val() == 'undefined') {
            new DialogMessage({
                title: Lang.get('frontend.errormsg.cart.allpay.shipping.map'),
            }, {
                'closeTimeout': 4000
            }).handle();
        } else {
            setBuyerCookie(function () {
                $('#allpayForm').submit();
            });
        }
    });

    // GoodDeal 超商取貨
    $('#gooddeal_map').click(function () {
        setBuyerCookie();
        setTimeout(function () {
            $('#js_map_area').find('form').submit();
        }, 500);
    });

    // paynow 超商取貨
    $('#paynow_map').click(function () {
        let shippingId = $('#shipping').val();
        let country = $('#PaynowOverseaCountry').val();

        if (shippingId == '417' && country != 'HK' && country != 'SG' && country != 'MY' && country != 'MO' && country != 'TH') {
            shippingMessage(Lang.get('frontend.errormsg.address.country.isRequired'));
        } else {
            setBuyerCookie(function () {
                $('#PayNowMap').submit();
            });
        }
    });

    // 智能櫃 超商取貨
    $('#palmbox_map').click(function () {
        setBuyerCookie(function () {
            $('#PalmboxMap').submit();
        });
    });

    // 向下滑動效果
    function slideDownStyle(element, target, status, reverse) {
        if (typeof reverse === "undefined") {
            reverse = true;
        }
        var slideUp = function () {
            target.animate({"height": 0}, 300, function () {
                target.css("height", "").hide();
            });
        }
        element.on(status, function () {
            if (status == "change") {
                if ($(this).prop("checked") == reverse) {
                    target.fadeIn(800);
                } else {
                    slideUp()
                }
            } else if (status == "click") {
                if (target.is(":visible")) {
                    slideUp();
                } else {
                    target.fadeIn()
                }
            }
        });
    }

    // slideDownStyle( $(".js_edm"), $(".js_email_success"), "change" );
    slideDownStyle($('#same_info'), $(".js_addressee_block"), "change", false);
    slideDownStyle($(".js_invoice"), $(".js_invoice_info"), "click");

    // 發票: 類別選擇
    $('#orders_invoice').change(function () {
        var invoice_type_id = $(this).val();
        invoiceAction(invoice_type_id);
    });

    // 發票: 個人發票載具選擇
    $('#carrier_type').change(function () {
        var carrier_type = $(this).val();
        carrierAction(carrier_type);
    });

    // 發票: 開立紙本發票
    $('#hard_copy').change(function () {
        if ($(this).is(':checked')) {
            $('#invoice_address_area').removeClass('d-none');
        } else {
            $('#invoice_address_area').addClass('d-none');
        }
    });

    // 發票: 同收件地址
    $('#copy_receiver_address').change(function () {
        if ($(this).prop('checked')) {
            var shipping = $('#shipping').val();
            if (shipping == 231) {
                var copy_address =
                    $('#int_receiver_address').val()
                    + ' '
                    + $('#js_receiver_region').val()
                    + ' '
                    + $('#js_receiver_city').val()
                    + ' '
                    + $('#int_receiver_country option:selected').text()
                    + ' '
                    + $('#int_receiver_zip').val();
            } else {
                if (shipping.indexOf('custom') != '-1'
                    && shipping_options[shipping]['setting']['has_address'] == '1'
                    && shipping_options[shipping]['setting']['in_taiwan'] == '0'
                ) {
                    var copy_address =
                        $('#int_receiver_address').val()
                        + ' '
                        + $('#js_receiver_city').val()
                        + ' '
                        + $('#js_receiver_region').val()
                        + ' '
                        + $('#receiver_country_select option:selected').text()
                        + ' '
                        + $('#int_receiver_zip').val();
                } else {
                    var copy_address =
                        $('.js_receiver_city').val()
                        + $('.js_receiver_district').val()
                        + $('#receiver_address').val();
                }
            }

            $('#invoice_address').val(copy_address);
        } else {
            $('#invoice_address').val('');
        }
    });

    $('.js_twzipcode_wrapper').append('<span class="form_select_bind js_select_bind"></span>');

    if ($(document).width() < 480) {
        $("#customer_text").attr("rows", 2);
    }

    $(document).on("click", ".js_after_sales", function () {
        var type = $(this).data('value');
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: after_sales_url,
            data: {type: type},
            success: function (result) {
                if (result.type == '1') {

                    $('.js_after_sales_info').html(result.rules);

                } else if (result.type == '3') {
                    $('.js_reservation_info').html(result.rules);
                } else {

                    $('.js_after_sales_redeem_info').html(result.rules)

                }

            }
        });
    });

    $("#receiver_country_select").combobox({
        placeholder: Lang.get('frontend.cart.title.placeholder.receiver_address_country')
    });

    $("#receiver_region_select").combobox({
        placeholder: Lang.get('frontend.member.recipient.placeholder.state')
    });

    $("#receiver_city_select").combobox({
        placeholder: Lang.get('frontend.member.recipient.placeholder.city')
    });

    var datetimeLocale = 'en';
    if (getLocale == 'tw') {
        datetimeLocale = 'zh-tw'
    } else if (getLocale == 'cn') {
        datetimeLocale = 'zh-cn'
    }

    Date.prototype.yyyymmdd = function () {
        var mm = this.getMonth() + 1; // getMonth() is zero-based
        var dd = this.getDate();

        return [this.getFullYear(),
            (mm > 9 ? '' : '0') + mm,
            (dd > 9 ? '' : '0') + dd
        ].join('-');
    };

    if ($('#shipping').val() !== '151') {
        var tomorrow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
        var tomorrow_date = tomorrow.yyyymmdd();
        var year = new Date(new Date().getTime() + 24 * 60 * 60 * 1000 * 365);
        var year_date = year.yyyymmdd();

        shippingDatePicker.init();
        if (shippingDatePicker.datePicker) {
            shippingDatePicker.datePicker.updateOptions({
                restrictions: {
                    minDate: tomorrow_date,
                    maxDate: year_date,
                },
                localization: {
                    locale: datetimeLocale,
                    format: 'yyyy-MM-dd',
                    startOfTheWeek: 0
                }
            });
        }
    }

    $('#is_holiday_send').click(function () {
        var is_holiday_send = $(this).is(':checked') ? 1 : 0;
        $('#is_holiday_send_val').val(is_holiday_send);
    });

    $('.js_credit_able button').click(function () {
        var status = $(this).data('status');
        var payment = $('#payment').val();
        if (payment == 346) {
            var creditAbleAreaElm = $('.js_paynow_credit_able_area');
        } else {
            var creditAbleAreaElm = $('.js_ecpay_credit_able_area');
        }
        if (status == 'on') {
            $(this).data('status', 'off');
            creditAbleAreaElm.addClass('d-none');
            $(this).find('i').attr('class', 'icon-chevron-small-down');
        } else {
            $(this).data('status', 'on');
            creditAbleAreaElm.removeClass('d-none');
            $(this).find('i').attr('class', 'icon-chevron-small-up');
        }
    });

    if (orders_invoice_carrier_type != '') {
        carrierAction(orders_invoice_carrier_type);
    }

    if (orders_invoice_type != '') {
        invoiceAction(orders_invoice_type);
    }

    if (orders_same_info) {
        $('#same_info').click();
    } else if (same_info) {
        $('#same_info').click();
    }

    if ($('#shipping').val() == '231') {
        if (int_receiver_country != '') {
            if (shops_shipping_international_id != '') {
                var countryOption = $('#int_receiver_country option[data-ssiid="' + shops_shipping_international_id + '"]');
                if (countryOption.length > 0) {
                    countryOption[0].selected = true
                }
            }

            if ($('#int_receiver_country').val() !== int_receiver_country) {
                $('#int_receiver_country').val(int_receiver_country);
            }

            $("#int_receiver_country").change();
        }
        if (int_receiver_city != '') {
            $('#js_receiver_city').val(int_receiver_city);
        }

        if (int_receiver_district != '') {
            $('#js_receiver_region').val(int_receiver_district);
        }
    } else if ($('#shipping').val() == '417' || $('#shipping').val() == '418') {
        setInternationalCountry();
        var paynowOverseaCountry = int_receiver_country || buyer_info.int_receiver_country;
        var paynowOverseaCity = int_receiver_city || buyer_info.int_receiver_city_name;
        var paynowOverseaDistrict = int_receiver_district || buyer_info.int_receiver_district_name;

        if (paynowOverseaCountry != '') {
            $('#int_receiver_country').val(paynowOverseaCountry);
            $("#int_receiver_country").change();
        }

        if (paynowOverseaCity != '') {
            $('#js_receiver_city').val(paynowOverseaCity);
        }


        if (paynowOverseaDistrict != '') {
            $('#js_receiver_region').val(paynowOverseaDistrict);
        }
    }

    if (is_holiday_send == 1) {
        $("#is_holiday_send").prop('checked', true);
        $('#is_holiday_send_val').val(is_holiday_send);
    }

    // 自訂運送
    $('#receiver_country_select').on('change', function () {
        var allowList = JS_VARS.allowList,
            selectShipping = $('#shipping').val();

        if ($.inArray(selectShipping, allowList) < 0) {
            return;
        }

        internationalAddress.updateOptions($(this));
    });

    $("#js_receiver_country")
        .addClass('form_input form_control')
        .closest('.form_select_block')
        .find('.ui-button')
        .attr('data-view', Lang.get('frontend.browsing.history.view'));

    $("#js_receiver_region").on("input change", function () {
        var postReceiverRegionElemet = $('#receiver_region');
        postReceiverRegionElemet.val($(this).val());
    }).addClass('form_input form_control')
        .closest('.form_select_block')
        .find('.ui-button')
        .attr('data-view', Lang.get('frontend.browsing.history.view'));

    $("#js_receiver_city").on("input change", function () {
        var postReceiverCityElemet = $('#receiver_city');
        postReceiverCityElemet.val($(this).val());
    }).addClass('form_input form_control')
        .closest('.form_select_block')
        .find('.ui-button')
        .attr('data-view', Lang.get('frontend.browsing.history.view'));

    $("#receiver_city_select").on('change', function () {
        var optionCityID = $("option:selected", this).attr("geonameid");
        var postReceiverCityElemet = $('#receiver_city');
        postReceiverCityElemet.val(optionCityID);
    });

    $("#receiver_region_select").on('change', function () {
        var optionRegionID = $("option:selected", this).attr("geonameid");
        var postReceiverRegionElemet = $('#receiver_region');
        postReceiverRegionElemet.val(optionRegionID);
    });

    var paymentInitView = function () {
        if ($('.js_select_subscribe').length > 0) {
            $('.js_select_subscribe').trigger('change');
        }
    };

    paymentInitView();

    // 設定我的購物車，組合包樣式
    function setCartBundleItemStyle(bundleId) {
        const isOpen = $('input#' + bundleId).is(':checked');
        const bundleSwitchDom = $('.bundle_sales_switch[for="' + bundleId + '"]');

        if (isOpen) {
            bundleSwitchDom.attr('style', bundleSwitchDom.data('active-style'));
        } else {
            bundleSwitchDom.attr('style', bundleSwitchDom.data('style'));
        }
    }

    $(document).on('click', '.js_coupon_sale_copy' , function () {
        copyDefaultCoupon();
    });

    // 兌換商品詳情檢視
    cart_detail_area.on('click', '.js_exchange_lightbox', function(e) {
        e.preventDefault();

        const productId = $(this).data('product-id');
        const standardId = $(this).data('standard-id');

        exchangeProductLightbox(productId, standardId, (confirmInstance) => {
            confirmInstance.$el.find('.js_add_exchange').hide();
        });
    });


    $('#js_cart_detail_area').on('click', '.js_cart_member_onsale', function(e){
        $('.js_member_login_modal').trigger('click');
    });

    const uss = new UserStatusService();
    uss.setCallback(function(result){
        // 美安
        const americaMarketInstance = new AmericaMarketStorage();
        $('#js_americaMarket_rid').val(americaMarketInstance.getStorageRid());
        $('#js_americaMarket_click_id').val(americaMarketInstance.getStorageClickId());

        (new PushAds()).start();

        recordUserViewTrack(cartCheckoutPage, '', {
            'amount': Number(cart_total),
        });
    });
});
